// Constants for different requests for current reducer
export default {
  notebookNoteTags: 'NOTEBOOK_NOTE_TAGS',
  updateNotebookNoteTags: 'UPDATE_NOTEBOOK_NOTE_TAGS',
};
